<template>
  <div class="attached-file-card shadowed-card"
       @click="viewPrescription">
    <full-screen-loader v-if="loading"/>
    <div class="flex-row-center-x-spaced">
      <span class="ns-icon-ico020 ns-large-icon"
            slot="icon">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
      <text-string slot="placeholder" label-id="txt327"/>
    </div>

    <slot></slot>
  </div>
</template>

<script>
  import {MedicineService} from '@/services/medicine';
  import ToastMixin from '@/mixins/toast-mixin';
  // import ModalPreviewFile from '@/components/preview-file';
  import TitleMixin from "@/mixins/title-mixin";
  import Routes from "@/router/routes";

  export default {
    name: 'attached-file-card',
    mixins: [
      TitleMixin,
      ToastMixin,
    ],
    props: {
      prescription: {type: Object, required: true},
      orderid: {type: String, required: true},
    },
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      async viewPrescription() {
        this.loading = true;
        try {
          const {data} = await MedicineService.getOrderFile(this.orderid, this.prescription.uploadid);

          if (data.url) {
            await this.$router.push({
              name: Routes.MEDICINE_ORDER_PREVIEW_FILE,
              params: {
                file: [data.url],
                title: 'Attached File',
                showButton: false
              }
            })
          } else {
            throw Error();
          }

          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.showToast({
            text: 'Failed to view file. Please try again later.',
            theme: 'danger',
          });
        }
      },
    },
  }
</script>

<style lang="scss">
  .attached-file-card {
    cursor: pointer;

    .smd-list-selection-panel {
      border: 0;
    }
  }
</style>
